import React from 'react'
import Modal from '@components/common/modal/Modal'

interface InfoModalProps {
  title: string
  content: React.ReactNode
  width?: string
  close: () => void
}

const InfoModal = ({
  title,
  content,
  close,
  width = '1000px',
}: InfoModalProps) => {
  return (
    <Modal title={title} hideModal={close} color="#001940" width={width}>
      {content}
    </Modal>
  )
}

export default InfoModal
